import { Locale, OutputChannels } from '../types';
import { LocaleStore, LocaleActions } from './types';

export const defaultState: LocaleStore = {
  locale: Locale.EN,
  onlineChannel: OutputChannels.DE,
};

const reducer = (
  state: LocaleStore = defaultState,
  action: { type: LocaleActions; payload?: any }
): LocaleStore => {
  switch (action.type) {
    case LocaleActions.SetLocale: {
      return {
        ...state,
        locale: action.payload,
      };
    }
    case LocaleActions.SetOnlineChannel: {
      return {
        ...state,
        onlineChannel: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};

export default reducer;
